import {Action} from './types';

export function isInactive<T extends object>(
  action: Pick<Action<T>, 'inactive'>,
  selectedItems: T
): boolean {
  return typeof action.inactive === 'function'
    ? action.inactive(selectedItems)
    : action.inactive ?? false;
}

export async function canExecuteAction<T extends object>(
  action: Pick<Action<T>, 'inactive' | 'inactiveAsync'>,
  selectedItems: T
): Promise<boolean> {
  if (isInactive(action, selectedItems)) {
    return false;
  }
  return !(await action.inactiveAsync?.(() => undefined));
}
